import { getIsFreeEmail, getUser, hasAccessToBusinessUnit
// @ts-expect-error not migrated to TS yet
} from 'EmailData/selectors/user';
// @ts-expect-error not migrated to TS yet
import EmailExportDialog from 'email-management-lib/refactor/components/shared/EmailExportDialog';
import { VISIBLE_TO } from 'email-management-lib/Shared/constants/manage';
import { exportEmailsInFramework } from 'email-management-lib/refactor/actions/manage/general';
import { COLUMNS_IN_VIEW_ONLY } from 'email-management-lib/refactor/constants/manage/exportConstants';
import useCrmSearchQuery from 'framework-listing-lib/hooks/useCrmSearchQuery';
import useCurrentView from 'framework-listing-lib/hooks/useCurrentView';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ExportModal({
  isOpen,
  onClose
}) {
  const currentView = useCurrentView();
  const canAccessBusinessUnit = useSelector(hasAccessToBusinessUnit);
  const isFree = useSelector(getIsFreeEmail);
  const user = useSelector(getUser);
  const hasFullDashboardAccess = user.hasFullDashboardAccess();
  const {
    filterGroups,
    objectTypeId,
    query,
    sorts
  } = useCrmSearchQuery();
  const doExport = useCallback(data => {
    const columns = currentView ? currentView.columns : [];
    let _columns = null;
    if (data.allCrmColumns === COLUMNS_IN_VIEW_ONLY || data.allCrmColumns === undefined) {
      _columns = [];
      columns.forEach(col => {
        if (col.name !== VISIBLE_TO) {
          _columns.push(col.name);
        }
      });
    }
    return exportEmailsInFramework(Object.assign({}, data, {
      crmSearchRequest: {
        filterGroups,
        objectTypeId,
        query,
        sorts
      },
      columns: _columns,
      currentUserId: user.user_id
    }));
  }, [currentView, filterGroups, objectTypeId, query, sorts, user.user_id]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(EmailExportDialog, {
    canAccessBusinessUnit: canAccessBusinessUnit,
    closeModal: onClose,
    doExport: doExport,
    hasFullDashboardAccess: hasFullDashboardAccess,
    isFree: isFree,
    isUseInFramework: true
  });
}